export default {
  label: 'Nombre de la Campaña',
  placeholder: 'Ninguna',
};
